// src/PrivateRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>; // You can show a loading spinner or any other loading indicator here
  }

  return user ? children : <Navigate to="/" />;
};

export default PrivateRoute;